import type { IInputNullableIntModelValueType, IInputNullableIntPropsWithoutModelValue } from '@/components';
import { reactive, type Ref } from 'vue';
import { DropdownItemBase } from './DropdownItemBase';

type IDropdownItemIntNullableInput = {
    [K in keyof IInputNullableIntPropsWithoutModelValue]: undefined extends IInputNullableIntPropsWithoutModelValue[K]
        ? IInputNullableIntPropsWithoutModelValue[K] | Ref<Exclude<IInputNullableIntPropsWithoutModelValue[K], undefined>> | undefined
        : IInputNullableIntPropsWithoutModelValue[K] | Ref<IInputNullableIntPropsWithoutModelValue[K]>;
};

export class DropdownItemIntNullableInput extends DropdownItemBase {
    modelValue: Ref<IInputNullableIntModelValueType>;

    props: IInputNullableIntPropsWithoutModelValue;

    get uniqueLoopKey() {
        return `${this.props.id}-${this.props.label}-${this.props.placeholder}-${this.props.icon}`;
    }

    private abuseBlocker: boolean = false;

    private constructor(
        modelValue: Ref<IInputNullableIntModelValueType>,
        props: IDropdownItemIntNullableInput,
        hideDropDownItem?: Ref<boolean>,
    ) {
        super();
        this.modelValue = modelValue;
        this.hideDropDownItem = hideDropDownItem;
        this.props = reactive(props);
    }

    public static create(
        options: { modelValue: Ref<IInputNullableIntModelValueType> } & IDropdownItemIntNullableInput &
            Pick<DropdownItemBase, 'hideDropDownItem'>,
    ): DropdownItemIntNullableInput {
        const { modelValue, hideDropDownItem, ...props } = options;
        return new DropdownItemIntNullableInput(modelValue, props, hideDropDownItem);
    }
}
